module.exports = __webpack_public_path__ + "src/img/agromajbau-logo.png";